<template>
  <div>
    <!-- render month names into a 4 * 3 matrix -->
    <b-list-group-item variant="primary"
      >Which day were you born on in {{ monthName }}</b-list-group-item
    >
    <b-container :fluid="true">
      <div v-for="(item, key) in daysList" :key="key">
        <b-row class="my-2">
          <b-col v-for="(row, key) in item" :key="key">
            <b-button block variant="outline-info" @click="openPicker(row)">{{
              row
            }}</b-button>
          </b-col>
        </b-row>
      </div>
        <b-row class="my-2">
            <b-col>
                <b-button block variant="success" :to="{name:'month-picker'}">Back to months</b-button>
            </b-col>
        </b-row>
    </b-container>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    monthName() {
      return this.$route.params.monthName;
    },
    monthNum() {
      return this.$route.params.monthNum;
    },

    daysList() {
      const monthName = this.$route.params.monthName;
      const daysInMonth = this.daysInMonth[monthName];
      return this.listOfDays(daysInMonth);
    },
  },
  methods: {
    listOfDays(daysInMonth) {
      const daysPerRow = Math.ceil(daysInMonth / this.noRows);
      // returns an array of days up to length of month .... like this [1,2,3,4,5]
      var rows = []; // will contain an array of days for each row like this [[1,2,3,4,5],[6,7,8,9,10].....etc]
      var outerCounter = 1;
      var innerCounter = 1; // will become the day in the row as its incremented
      //loop over rows calling inner loop to build row
      for (outerCounter; outerCounter <= this.noRows; outerCounter++) {
        const row = []; // empty array for row to be built in
        let end = outerCounter * daysPerRow; // the end number for the row being built eg 1st row 1*5 = 5 2nd row 2*5 = 10
        if (end > daysInMonth) {
          end = daysInMonth;
        } // dont overbuild the last row
        for (innerCounter; innerCounter <= end; innerCounter++) {
          row.push(innerCounter);
        }
        rows.push(row);
      }
      return rows;
    },
    



    openPicker(day) {
      
        this.$router.push({
          name: "person-picker",
          params: { month: this.monthName, day: day, monthNum:this.monthNum },
        });
   
    },
  },

  data() {
    return {
      daysInMonth: {
        January: 31,
        February: 29,
        March: 31,
        April: 30,
        May: 31,
        June: 30,
        July: 31,
        August: 31,
        September: 30,
        October: 31,
        November: 30,
        December: 31,
      },
      noRows: 5,
    };
  },
};
</script>

<style scoped></style>
